// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import ElementUI from 'element-ui'
import GlobalComponent from '@utils/globalComponents'
import '@utils/globalFilter'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@utils/permission'
// vantUI框架
import Vant from 'vant'
import 'vant/lib/index.css'
import AFTableColumn from 'af-table-column'

import mixin from '@/mixin/mixin'
Vue.mixin(mixin)
Vue.use(Vant)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.use(GlobalComponent)
Vue.use(AFTableColumn)
Vue.config.productionTip = false

Vue.prototype.$copy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
let com = 'https://go.tiantaisl.com/'
Vue.prototype.airLineImgUrl = `${com}img/intairpic/`
Vue.prototype.hotelImgUrl = `${com}img/hotel/`
Vue.prototype.systemName = '天泰商旅'
Vue.prototype.drive = 'WEB'
Vue.prototype.version = '1.1.0.2'
Vue.prototype.browser = {
  versions: (function () {
    var u = navigator.userAgent
    // var app = navigator.appVersion;
    // 移动终端浏览器版本信息
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
    }
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
Vue.prototype.$cancelReq = async () => {
  if (
    store.state.login._axiosPromiseCancel &&
    store.state.login._axiosPromiseCancel.length
  ) {
    store.state.login._axiosPromiseCancel.forEach(e => {
      e && e()
    })
    store.state.login._axiosPromiseCancel = []
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js